import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {Company} from "./api.models";
import {Observer} from "rxjs/Observer";

export class CompaniesEndpoint extends Request {
    protected cache: Company[];
    protected cacheToken: string;

    collection(): Observable<Company[]> {
        return Observable.create((observer: Observer<any>) => {
            if (this.cache && this.cacheToken === this.settings.token) {
                observer.next(this.cache);
                observer.complete();

                return;
            }

            this.get('/v1/companies').subscribe(
                (companies: Company[]) => {
                    this.cache      = [];
                    this.cacheToken = this.settings.token;
                    companies.forEach((company: Company) => {
                        this.cache.push(Object.assign(company));
                    });

                    observer.next(companies);
                },
                (error: any) => {
                    observer.error(error);
                },
                () => {
                    observer.complete();
                }
            );
        });
    }

    add(company: Company): Observable<Company> {
        this.cache = null;

        return this.post('/v1/companies', company);
    }

    update(company: Company): Observable<Company> {
        this.cache = null;

        return this.patch('/v1/companies/' + company.id, company);
    }

    remove(id: number): Observable<Boolean> {
        this.cache = null;

        return this.delete('/v1/companies/' + id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/companies/api.service.ts